import React, { useEffect, useRef, useState } from "react";
import TableHead, { TTableHeadProps, TTableLabel, TTHPropper, TTHProps } from "./TableHead";
import UserPref from "../UserPref";
import TableBody, { TTableBodyProps, TTableRowKey } from "./TableBody";
import { TTableRow } from "./TableConst";
import { TTableCellProps, TTableCellText, TTableCellValue } from "./TableCell";
import { TTableRowProps, } from "./TableRow";
import TableFooter from "./TableFooter";

export type { 
    TTableLabel, TTableCellValue, TTableCellText, TTableRowKey, TTHPropper, TTHProps, TTableHeadProps, TTableBodyProps, TTableRowProps, TTableCellProps, 
}
export type TTableProps<T extends TTableRow> = React.ComponentPropsWithoutRef<"table"> & Omit<TTableHeadProps,"sort"|"onSort"> & TTableBodyProps<T> & {
    tableName?:string
    rows:T[]
    footer?:T[]
    sortResolver?:string[]
}

export function tableSort<T extends TTableRow>(rows:T[], col:string, cellValue:TTableCellValue<T>|undefined, sortResolver:string[]|undefined){
    if (!col) return rows
    const dir = col[0]=="-" ? -1 : 1
    const s_col = dir<0 ? col.substring(1) : col
    const value = cellValue || ((row:T,col:string) => row[col])
    const comp = (l:T, r:T, col:string, dir:number) => {
        const left = value(l, col) , right = value(r, col)
        if (typeof(left)=="string" && typeof(right)=="string") return dir * left.localeCompare(right)
        else if (left instanceof Date && right instanceof Date) return dir * (left.getTime()-right.getTime())
        else return dir * (left<right ? -1 : 1)
    }
    return rows.sort((l:T,r:T) => {
        var c = comp(l, r, s_col, dir)
        if (c || !sortResolver) return c
        else {
            for(const col of sortResolver){
                if (col==s_col) continue
                c = comp(l, r, col, 1)
                if (c) return c
            }
            return 0
        }
    })    
}
export default function Table<T extends TTableRow>(props:TTableProps<T>) {
    const {tableName,rows,cols,label,rowKey,cellValue,cellText,tr,td,th,htr,disableSort,footer,sortResolver,...tableProps} = props
    const sortKey = props.tableName ? `${props.tableName}_sort` : "table_sort"
    const [sort,setSort] = useState<string>(UserPref.i.get(sortKey)||"")
    const [filteredRows,setFilteredRows] = useState<T[]>(tableSort(props.rows, sort, cellValue, sortResolver))
    const mounted = useRef<boolean>(false)

    const onSort = (sort:string) => {
        setSort(sort)
        UserPref.i.set(sortKey, sort)
        setFilteredRows(tableSort(props.rows, sort, cellValue, sortResolver))
    }

    useEffect(() => {
        if (mounted.current) onSort(sort)
        else mounted.current = true
    },[rows])

    return <table {...tableProps}>
        <TableHead cols={cols} label={label} htr={htr} th={th} onSort={onSort} sort={sort} disableSort={disableSort}/>
        <TableBody rows={filteredRows} cols={cols} rowKey={rowKey} tr={tr} td={td} cellValue={cellValue} cellText={cellText}/>
        {footer ? <TableFooter footer={footer} cols={cols} rowKey={rowKey} tr={tr} td={td} cellValue={cellValue} cellText={cellText}/> : <></>}
    </table>
}